import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/DashboardSidebar";
import { ArrowRight } from "lucide-react";
//import "./DashboardLayout.css";

export default function DashboardLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  // Show sidebar only on the dashboard root
  const isRoot = location.pathname === "/dashboard";

  return (
    <div className="dashboard-layout">
      <aside className={`dashboard-sidebar ${isRoot ? "show" : "hide"}`}>
        <Sidebar />
      </aside>

      <main className={`dashboard-content ${isRoot ? "hide" : "show"}`}>
        {!isRoot && (
          <button
            className="dashboard-back"
            onClick={() => navigate("/dashboard")}
          >
            <ArrowRight size={20} />
            بازگشت به پروفایل
          </button>
        )}

        <Outlet />
      </main>
    </div>
  );
}
